import { z } from 'zod';
/**
 * Canonical primitive schemas. Import from here rather than redefining
 * so that validation rules stay consistent across every endpoint.
 */
export const emailSchema = z
    .string()
    .trim()
    .toLowerCase()
    .email()
    .max(254);
export const passwordSchema = z
    .string()
    .min(10, 'Password must be at least 10 characters')
    .max(200, 'Password must be 200 characters or fewer');
export const handleSchema = z
    .string()
    .trim()
    .toLowerCase()
    .regex(/^@?[a-z0-9_]{3,24}$/, 'Handle must be 3–24 characters: letters, digits, underscore')
    .transform((v) => v.replace(/^@/, ''));
export const displayNameSchema = z.string().trim().min(1).max(80);
export const personNameSchema = z.string().trim().min(1).max(60);
export const breakerIdSchema = z
    .string()
    .regex(/^\d{8}$/, 'Breaker ID must be 8 digits');
export const idSchema = z
    .string()
    .regex(/^[0-9A-HJKMNP-TV-Z]{26}$/, 'Not a valid ULID');
export const ukPhoneSchema = z
    .string()
    .trim()
    .regex(/^\+44\d{9,10}$/, 'Must be E.164 UK number, e.g. +447123456789');
export const fleetSlugSchema = z
    .string()
    .trim()
    .toLowerCase()
    .regex(/^[a-z0-9][a-z0-9-]{1,38}[a-z0-9]$/, 'Slug must be 3–40 chars, a–z, 0–9, hyphen');
/**
 * Unit D: client-minted idempotency key for high-stakes mutations. One key
 * per ACTION INSTANCE (reused across retries/double-taps, rotated on
 * success); the server no-ops replays. UUIDs or 32-hex both fit.
 */
export const idempotencyKeySchema = z.string().trim().min(16).max(80);
export const paginationSchema = z.object({
    cursor: z.string().optional(),
    limit: z.coerce.number().int().min(1).max(100).default(50),
});
//# sourceMappingURL=common.js.map